import { useEffect } from 'react';
import { ConfigProvider, App as AntdApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { RouterProvider } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { router } from '@/router';
import { useSessionStore } from '@/store/session';

// dayjs 的 locale 是全局的，且与 antd 的 locale 相互独立 —— 只配 ConfigProvider 的话，
// DatePicker 的面板是中文、而代码里 dayjs().format('dddd') 仍然出英文。
dayjs.locale('zh-cn');

/**
 * 会话引导。挂在 RouterProvider **之上**：必须在任何路由渲染之前把 status 从 'loading'
 * 推进到确定态，否则 RequireAuth 会拿着未初始化的状态做跳转判断。
 */
function SessionBootstrap({ children }: { children: React.ReactNode }) {
  const bootstrap = useSessionStore((s) => s.bootstrap);
  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);
  return <>{children}</>;
}

export default function App() {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#1677ff',
          borderRadius: 6,
        },
      }}
    >
      {/* AntdApp 提供 message / notification / Modal 的 context 版本（App.useApp()），
          这是让反馈组件拿到上面这套 theme 与 locale 的唯一方式。 */}
      <AntdApp>
        <SessionBootstrap>
          <RouterProvider router={router} />
        </SessionBootstrap>
      </AntdApp>
    </ConfigProvider>
  );
}
